const expandFilterOptions = (enumOptions) => [['all', 'All'], ...enumOptions];
export default expandFilterOptions;
